import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

const currentUserQuery = gql`
  query bannerMessageCurrentUser {
    currentUser: currentUserV2 {
      bannerMessage
      id
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useData = ({ skip }: Props = {}) => {
  const { data, loading } = useQuery(currentUserQuery, {
    skip,
  });

  return {
    bannerMessage: data?.currentUser?.bannerMessage,
    isLoading: loading,
    shouldRender: !!data?.currentUser?.bannerMessage,
  };
};
